// extracted by mini-css-extract-plugin
export default {"container":"Head_container__FdyjK","left":"Head_left__1YYk4","picture":"Head_picture__5SKz3","details":"Head_details__1d+1z","title":"Head_title__Qo6vs"};